jQuery(document).ready(function($){
    
    //MOBILE MENU
    $('.mobile-menu-button').click(function(){
        $(this).toggleClass('is-active');
        $('.mobile-menu-container').toggleClass('mobile-menu-show');

        if ($('.mobile-menu-container').hasClass('mobile-menu-show')){
            $('body').css('overflow-y', 'hidden');
         }
         else{
            $('body').css('overflow-y', 'scroll');

         }
    });

    $('.mobile-menu-container .menu-item-has-children').append('<button tabindex="0" class="toggle-sub-menu-button"><span class="toggle-sub-menu fas fa-angle-down"><span class="sr-only">Toggle sub menu</span></span></button')

    $(document).on('click', '.mobile-menu-container .menu-item-has-children .toggle-sub-menu-button', function(){
        $(this).siblings('.sub-menu').slideToggle();

        var icon = $(this).children('.toggle-sub-menu');
        if (icon.hasClass('fa-angle-down')){
            icon.removeClass('fa-angle-down');
            icon.addClass('fa-angle-up');
        }
        else{
            icon.removeClass('fa-angle-up');
            icon.addClass('fa-angle-down');
        }
    })


    //DESKTOP SUB MENU

    adjustSubMenuPosition();
    $(window).resize(function(){
        adjustSubMenuPosition();
    })

    function adjustSubMenuPosition(){
        var headerHeight = $('.header').outerHeight();
        $('ul#desktop-menu > .menu-item-has-children > .sub-menu-wrap').css('top', (headerHeight -1)+ 'px');

    }

    $('ul#desktop-menu > .menu-item-has-children > a').append('<span class="toggle-sub-menu mt-3 far fa-angle-down"><span class="sr-only">Toggle sub menu</span></span>')

    // $('ul#desktop-menu > .menu-item-has-children').click(function(){
    //     alert('test');
    //     $(this).find('.sub-menu-wrap').toggleClass('sub-menu-wrap-show');
    // });
    

});